import { render, staticRenderFns } from "./TheDocumentsModal.vue?vue&type=template&id=60e90876&"
import script from "./TheDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./TheDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports